import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import { Text } from "react-native";
// import { styleSheet, colors, sizes } from "app/utils/styleSheet";
import haptics from "app/utils/haptics";
import { StyleContext } from "app/contexts/Style";

export default class CustomText extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    bold: PropTypes.bool,
    medium: PropTypes.bool,
    light: PropTypes.bool,
    hidden: PropTypes.bool,
    italic: PropTypes.bool,
    strike: PropTypes.bool,
    small: PropTypes.bool,
    large: PropTypes.bool,
    // style
  };

  constructor(props) {
    super(props);
    let defaultHaptics = "light";
    let hapticFeedback = props.haptics == true ? defaultHaptics : props.haptics;
    this.state = {
      hapticFeedback,
    };
  }

  render() {
    let { style } = this.props;
    let styleArray = [];
    if (style && Array.isArray(style)) {
      styleArray = style;
    } else {
      styleArray = [style];
    }

    // filter non-style values
    styleArray = styleArray.map((s) => {
      if (!!s) {
        let { lineHeightRatio, ...validStyle } = s;
        return validStyle;
      }
      return s;
    });

    return (
      <Text
        {...this.props}
        pointerEvents={this.props.disabled ? "none" : undefined}
        onPress={
          ENV.WEB && !!this.props.onPress
            ? () => null
            : !!this.props.onPress
            ? (e) => {
                haptics.light();
                this.props.onPress(e);
              }
            : null
        }
        onLongPress={ENV.WEB ? undefined : this.props.onLongPress}
        // onMouseUp={ENV.WEB ? this.props.onPress : undefined}

        onMouseDown={ENV.WEB ? this.handleMouseDown : undefined}
        onMouseUp={ENV.WEB ? this.handleMouseUp : undefined}
        onMouseLeave={ENV.WEB ? this.cancelPress : undefined}
        style={[this.formatStyle(), ...styleArray]}
      >
        {this.props.children}
      </Text>
    );
  }

  handlePress = (e) => {
    // let { hapticFeedback } = this.state;
    // if (!!hapticFeedback) {
    //   haptics[hapticFeedback]();
    // }
    this.props.onPress(e);
  };

  handleMouseDown = (e) => {
    if (this.props.onMouseDown) this.props.onMouseDown(e);

    if (this.longPressListener) clearTimeout(this.longPressListener);

    this.mouseDownEvent = e;
    this.mouseDownAt = new Date().getTime();
    this.mouseUpAt = null;

    this.longPressListener = setTimeout(() => {
      if (!!this.mouseDownAt && !this.mouseUpAt) {
        this.mouseUpAt = null;
        this.mouseDownAt = null;
        this.props.onLongPress && this.props.onLongPress(e);
      }
    }, 500);
  };

  handleMouseUp = async (e) => {
    this.mouseUpAt = new Date().getTime();
    if (!!this.mouseDownAt) {
      if (this.mouseUpAt - this.mouseDownAt >= 500) {
        // this.props.onLongPress && this.props.onLongPress(e);
      } else {
        this.props.onPress && this.handlePress(this.mouseDownEvent);
      }
    }
    this.mouseDownAt = null;
  };

  cancelPress = () => {
    if (this.longPressListener) clearTimeout(this.longPressListener);
    this.mouseDownAt = null;
    this.mouseUpAt = null;
  };

  formatStyle = () => {
    let {
      bold,
      medium,
      light,
      trim,
      hidden,
      style,
      underline,
      italic,
      strike,
      button,
      selectedButton,
      smallButton,
      center,
      disabled,
      small,
      large,
      onPress,
    } = this.props;

    let size = this.context.sizes.default;
    // if (small) size = 10;
    if (small || smallButton) size = 12;
    if (large) size = 20;

    let defaultStyle = {
      color: this.context.colors.foreground,
      fontSize: size,
      minHeight: size,
      lineHeight: size * this.context.sizes.lineHeightRatio,
      fontFamily: "Helvetica",
    };

    if (light) defaultStyle.color = this.context.colors.lightForeground;
    if (trim) defaultStyle.color = this.context.colors.trim;

    if (underline) defaultStyle.textDecorationLine = "underline";
    if (hidden) defaultStyle.height = 0;
    if (italic) defaultStyle.fontStyle = "italic";
    if (bold) defaultStyle.fontWeight = "bold";
    if (light) defaultStyle.fontWeight = "100";
    if (strike) defaultStyle.textDecorationLine = "line-through";
    if (strike && underline)
      defaultStyle.textDecorationLine = "underline line-through";
    if (center) defaultStyle.textAlign = "center";

    if (style && Array.isArray(style)) {
      for (let sty of style) {
        if (sty && sty.fontSize && !sty.lineHeight) {
          defaultStyle.lineHeight =
            sty.fontSize *
            (style.lineHeightRatio || this.context.sizes.lineHeightRatio);
        }
      }
    } else if (style && style.fontSize && !style.lineHeight) {
      defaultStyle.lineHeight =
        style.fontSize *
        (style.lineHeightRatio || this.context.sizes.lineHeightRatio);
    }

    if (button || selectedButton || smallButton) {
      defaultStyle = {
        ...defaultStyle,
        padding: this.context.sizes.base,
        // borderRadius: this.context.sizes.borderRadius,
        borderRadius: this.context.sizes.smallBorderRadius,
        backgroundColor: this.context.colors.fill,
        marginRight: this.context.sizes.base,
        overflow: "hidden",
      };
    }
    if (smallButton) {
      defaultStyle = {
        ...defaultStyle,
        padding: this.context.sizes.tiny,
        paddingHorizontal: this.context.sizes.small,
        // paddingVertical: 0,
        // borderRadius: this.context.sizes.borderRadius,
        borderRadius: this.context.sizes.smallBorderRadius,
        backgroundColor: this.context.colors.fill,
        marginRight: this.context.sizes.base,
        overflow: "hidden",
      };
    }
    if (selectedButton) {
      defaultStyle = {
        ...defaultStyle,
        backgroundColor: this.context.colors.trim,
      };
    }
    if (disabled) {
      defaultStyle = { ...defaultStyle, opacity: 0.5 };
    }

    if (!!onPress && ENV.WEB) {
      defaultStyle = { ...defaultStyle, cursor: "pointer" };
    }

    return defaultStyle;
  };
}
